/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutSelectionRequest
 */
export interface CarveOutSelectionRequest {
    /**
     * 
     */
    carve_out_ids: Array<string>;
}

/**
 * Check if a given object implements the CarveOutSelectionRequest interface.
 */
export function instanceOfCarveOutSelectionRequest(value: object): value is CarveOutSelectionRequest {
    if (!('carve_out_ids' in value) || value['carve_out_ids'] === undefined) return false;
    return true;
}

export function CarveOutSelectionRequestFromJSON(json: any): CarveOutSelectionRequest {
    return CarveOutSelectionRequestFromJSONTyped(json, false);
}

export function CarveOutSelectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutSelectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'carve_out_ids': json['carve_out_ids'],
    };
}

export function CarveOutSelectionRequestToJSON(json: any): CarveOutSelectionRequest {
    return CarveOutSelectionRequestToJSONTyped(json, false);
}

export function CarveOutSelectionRequestToJSONTyped(value?: CarveOutSelectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carve_out_ids': value['carve_out_ids'],
    };
}

